import { Validators } from 'pages/OidcLogin/utils';
import { useState } from 'react';
import { IconButton, InputAdornment as MuiInputAdornment } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';

export type InputsData = {
  password: {
    value: string;
    hide: boolean;
    error: string;
  };
  passwordConfirmation: {
    value: string;
    hide: boolean;
    error: string;
  };
};

const defaultValues = {
  error: '',
  value: '',
  hide: true,
};

export function usePassword() {
  const [inputsData, setInputsData] = useState<InputsData>({
    password: defaultValues,
    passwordConfirmation: defaultValues,
  });

  const enableButton = Object.values(inputsData).every(input => !input.error && input.value);

  function handleInputChange(name: keyof InputsData, value: string) {
    setInputsData(prevData => ({
      ...prevData,
      [name]: {
        ...prevData[name],
        value,
      },
    }));
  }

  function handleInputWithError(name: keyof InputsData, value: string | Validators | null) {
    setInputsData(prevData => ({
      ...prevData,
      [name]: {
        ...prevData[name],
        error: value,
      },
    }));
  }

  function handleClickShowPassword(name: keyof InputsData) {
    setInputsData(prevData => ({
      ...prevData,
      [name]: {
        ...prevData[name],
        hide: !prevData[name].hide,
      },
    }));
  }

  const renderInputAdornment = (name: keyof InputsData) => {
    return (
      <>
        <MuiInputAdornment position="end">
          <IconButton
            aria-label="toggle password visibility"
            onClick={() => handleClickShowPassword(name)}
            color="primary"
          >
            {inputsData[name].hide ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </MuiInputAdornment>
      </>
    );
  };

  return {
    inputsData,
    enableButton,
    handleInputChange,
    renderInputAdornment,
    handleInputWithError,
  };
}
